import * as THREE from 'three';

// Dynamic TER vertices are local coordinates. The mapped display special's
// current matrix transforms them; adding the static group origin again would
// double-translate them (terrain.cpp dynamic ScanTerrain transforms).
export function createDynamicTerrain(terrain, resolvePlatform) {
  if (typeof resolvePlatform !== 'function') throw new Error('Dynamic terrain requires original platform bindings.');
  const meshes = [], unsupported = [], records = [];
  for (const group of terrain.groups.filter(group => group.dynamic)) {
    const binding = resolvePlatform(group.platformIndex);
    if (!binding) { unsupported.push(group.index); continue; }
    const positions = [];
    for (const block of group.blocks) for (const face of block.faces) {
      if (!face.degenerateTriangles?.[0]) for (const i of [0, 1, 2]) positions.push(...face.vertices[i]);
      if (!face.triangleOnly && !face.degenerateTriangles?.[1]) for (const i of [1, 3, 2]) positions.push(...face.vertices[i]);
    }
    const geometry = new THREE.BufferGeometry(); geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
    geometry.computeVertexNormals(); geometry.computeBoundingBox(); geometry.computeBoundingSphere();
    const mesh = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({ side: THREE.DoubleSide }));
    mesh.matrixAutoUpdate = false; mesh.userData.platformIndex = group.platformIndex; mesh.userData.terrainGroupIndex = group.index;
    meshes.push(mesh); records.push({ mesh, binding });
  }
  function update() {
    for (const { mesh, binding } of records) {
      const state = binding();
      mesh.userData.collisionActive = state?.active === true;
      if (!mesh.userData.collisionActive) continue;
      const matrix = state.matrix?.elements ?? state.matrix;
      if ((!Array.isArray(matrix) && !ArrayBuffer.isView(matrix)) || matrix.length !== 16 || ![...matrix].every(Number.isFinite)) throw new Error('Invalid dynamic terrain matrix.');
      mesh.matrix.fromArray(matrix); mesh.updateMatrixWorld(true);
    }
  }
  update();
  return { meshes, unsupported, update,
    get activeMeshes() { return meshes.filter(mesh => mesh.userData.collisionActive); },
    dispose() { meshes.forEach(mesh => { mesh.geometry.dispose(); mesh.material.dispose(); }); },
  };
}
